import React from 'react'
import { ReactComponent as ArrowNotification } from '../../../../assets/arrow_notification.svg'
import { COLORS } from '../../../../styles/colors'
import { TypographyPrimary16Bold } from '../../../../ui/typography/TypographyPrimary16Bold'
import { RU_LOCALE } from '../../constants/constants'
import { MonthPickerProps } from '../../types'
import {
	Header,
	MonthCell,
	MonthGrid,
	StyledMonthPicker,
} from './MonthPicker.styles'

/**
 * Компонент выбора месяца
 * Отображает сетку 3x4 с названиями всех месяцев
 */
const MonthPicker: React.FC<MonthPickerProps> = ({
	selectedMonth,
	onSelectMonth,
	onBack,
}) => {
	return (
		<StyledMonthPicker>
			<Header>
				<ArrowNotification
					onClick={onBack}
					style={{
						width: 24,
						height: 24,
						color: COLORS.icon,
						cursor: 'pointer',
					}}
				/>
			</Header>

			<MonthGrid>
				{RU_LOCALE.MONTHS.map((monthName, index) => {
					const isSelected = selectedMonth === index
					return (
						<MonthCell
							key={index}
							$isSelected={isSelected}
							onClick={() => onSelectMonth(index)}
						>
							<TypographyPrimary16Bold
								style={{ color: isSelected ? COLORS.main : COLORS.black }}
							>
								{monthName}
							</TypographyPrimary16Bold>
						</MonthCell>
					)
				})}
			</MonthGrid>
		</StyledMonthPicker>
	)
}

export default MonthPicker
